/*
 * ÉLINE L'ATELIER : règles de commande
 *  1. Vente par lot : un produit étiqueté « Lot de N » se commande par multiples de N
 *     (fiche produit, ajout rapide des catégories, panier). Une quantité hors lot est arrondie au lot supérieur.
 *  2. Minimum de commande : « Passer commande » reste bloqué tant que le panier est sous le minimum.
 * Données fournies par sections/eline-regles.liquid.
 */
(function () {
  'use strict';

  var source = document.getElementById('eline-regles-donnees');
  if (!source || window.elineRegles) return;
  var D;
  try {
    D = JSON.parse(source.textContent);
  } catch (e) {
    return;
  }

  var T = D.textes || {};
  var MINIMUM = parseInt(D.minimum, 10) || 0; // centimes, devise de la boutique
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fetchOrigine = window.fetch.bind(window);
  var CHAMPS = 'input.quantity__input, input[name="quantity"], input[data-quantity-variant-id]';

  /* ---------- Lots connus ---------- */

  var lotsVariante = {}; // id de variante -> lot
  var lotsHandle = {}; // handle produit -> lot
  var recherches = {}; // handle -> recherche en cours

  try {
    var cache = JSON.parse(sessionStorage.getItem('eline-lots') || '{}');
    if (cache && cache.t && Date.now() - cache.t < 30 * 60 * 1000) lotsHandle = cache.lots || {};
  } catch (e) {}

  function memoriser() {
    try {
      sessionStorage.setItem('eline-lots', JSON.stringify({ t: Date.now(), lots: lotsHandle }));
    } catch (e) {}
  }

  ((D.panier && D.panier.lignes) || []).forEach(function (l) {
    var n = parseInt(l.lot, 10) || 1;
    lotsVariante[l.variante] = n;
    if (l.handle) lotsHandle[l.handle] = n;
  });
  if (D.produit && D.produit.handle) lotsHandle[D.produit.handle] = parseInt(D.produit.lot, 10) || 1;

  function lotDesEtiquettes(tags) {
    var liste = Array.isArray(tags) ? tags : String(tags || '').split(',');
    var n = 1;
    liste.forEach(function (t) {
      var m = /^\s*lot\s+de\s+(\d+)\s*$/i.exec(String(t));
      if (m && parseInt(m[1], 10) > 1) n = parseInt(m[1], 10);
    });
    return n;
  }

  function lotParHandle(handle) {
    if (!handle) return Promise.resolve(1);
    if (lotsHandle[handle]) return Promise.resolve(lotsHandle[handle]);
    if (!recherches[handle]) {
      recherches[handle] = fetchOrigine(RACINE + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.json();
        })
        .then(function (p) {
          var n = lotDesEtiquettes(p.tags);
          lotsHandle[handle] = n;
          (p.variants || []).forEach(function (v) {
            lotsVariante[v.id] = n;
          });
          memoriser();
          return n;
        })
        .catch(function () {
          return 1;
        })
        .then(function (n) {
          delete recherches[handle];
          return n;
        });
    }
    return recherches[handle];
  }

  function handleDepuisLien(href) {
    var m = /\/products\/([^/?#.]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function arrondir(q, n) {
    if (!(n > 1) || !(q > 0)) return q;
    return Math.ceil(q / n) * n;
  }

  function texte(cle, valeurs) {
    var s = T[cle] || '';
    Object.keys(valeurs || {}).forEach(function (k) {
      s = s.split('{' + k + '}').join(valeurs[k]);
    });
    return s;
  }

  var minuteurAvis;
  function avis(message) {
    var el = document.getElementById('eline-avis');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(minuteurAvis);
    minuteurAvis = setTimeout(function () {
      el.hidden = true;
    }, 6000);
  }

  function attribut(el, nom, valeur) {
    valeur = String(valeur);
    if (el.getAttribute(nom) !== valeur) el.setAttribute(nom, valeur);
  }

  /* ---------- Champs de quantité ---------- */

  // Champ « quantité » du formulaire d'ajout au panier d'une fiche produit
  function estChampProduit(input) {
    return input.name === 'quantity';
  }

  function produitDuChamp(input) {
    if (!D.produit) return null;
    var form = input.form;
    var idProduit = form && form.querySelector('[name="product-id"]');
    if (idProduit) return String(idProduit.value) === String(D.produit.id) ? D.produit : null;
    return input.closest('product-info, [id^="MainProduct-"]') ? D.produit : null;
  }

  function handleDuChamp(input) {
    var bloc = input.closest(
      '.cart-item, quick-add-bulk, bulk-modal, quick-order-list, .card-wrapper, .product-card-wrapper, .grid__item, product-info'
    );
    if (!bloc) return null;
    var porteur = bloc.matches('[data-url*="/products/"]') ? bloc : bloc.querySelector('[data-url*="/products/"]');
    if (!porteur) porteur = input.closest('[data-url*="/products/"]');
    if (porteur) return handleDepuisLien(porteur.getAttribute('data-url'));
    var lien = bloc.querySelector('a[href*="/products/"]');
    if (!lien) {
      var modale = input.closest('bulk-modal, quick-add-modal, .quick-add-modal');
      var ouvreur = modale && modale.id && document.querySelector('[data-modal="#' + modale.id + '"]');
      var carte = ouvreur && ouvreur.closest('.card-wrapper, .product-card-wrapper, .grid__item');
      lien = carte && carte.querySelector('a[href*="/products/"]');
    }
    return lien ? handleDepuisLien(lien.getAttribute('href')) : null;
  }

  function appliquerLot(input, n) {
    n = parseInt(n, 10) || 1;
    attribut(input, 'data-eline-lot', n);
    if (n <= 1) return;
    attribut(input, 'step', n);
    attribut(input, 'data-min', n);
    // min = 0 sur l'ajout rapide des catégories (0 = pas dans le panier) : on le laisse
    if ((parseInt(input.getAttribute('min'), 10) || 0) > 0) attribut(input, 'min', n);
    if (estChampProduit(input)) {
      var v = parseInt(input.value, 10) || 0;
      if (v < n || v % n) input.value = arrondir(Math.max(v, n), n);
      noteProduit(input, n);
    } else if (input.closest('.cart-item')) {
      notePanier(input, n);
    }
    var qi = input.closest('quantity-input');
    if (qi && typeof qi.validateQtyRules === 'function') {
      try {
        qi.validateQtyRules();
      } catch (e) {}
    }
  }

  function noteProduit(input, n) {
    var bloc = input.closest('.product-form__quantity');
    var qi = input.closest('quantity-input');
    var note = (bloc || (qi && qi.parentElement) || document).querySelector('.eline-lot-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'eline-lot-note';
      if (bloc) bloc.appendChild(note);
      else if (qi) qi.insertAdjacentElement('afterend', note);
      else return;
    }
    var t = texte('lot_produit', { n: n });
    if (note.textContent !== t) note.textContent = t;
  }

  // Mention « Lot de N » sous le nom de l'article, dans le panier
  function notePanier(input, n) {
    var ligne = input.closest('.cart-item');
    var details = ligne && ligne.querySelector('.cart-item__details');
    if (!details) return;
    var note = details.querySelector('.eline-lot-panier');
    if (!note) {
      note = document.createElement('small');
      note.className = 'eline-lot-panier';
      details.appendChild(note);
    }
    var t = texte('lot_panier', { n: n });
    if (note.textContent !== t) note.textContent = t;
  }

  function lotConnu(input) {
    var pose = parseInt(input.getAttribute('data-eline-lot') || '0', 10);
    if (pose) return pose;
    if (estChampProduit(input)) {
      var p = produitDuChamp(input);
      if (p) return parseInt(p.lot, 10) || 1;
    }
    var v = input.getAttribute('data-quantity-variant-id');
    if (v && lotsVariante[v]) return lotsVariante[v];
    return 0;
  }

  function traiterChamp(input) {
    if (!input || input.type !== 'number') return;
    var n = lotConnu(input);
    if (n) return appliquerLot(input, n);
    var handle = handleDuChamp(input);
    if (!handle || input.dataset.elineRecherche === handle) return;
    input.dataset.elineRecherche = handle;
    lotParHandle(handle).then(function (lot) {
      var v = input.getAttribute('data-quantity-variant-id');
      if (v) lotsVariante[v] = lot;
      appliquerLot(input, lot);
    });
  }

  function traiterTout(racine) {
    (racine || document).querySelectorAll(CHAMPS).forEach(traiterChamp);
  }

  // Le thème remet le pas à 1 quand on change de couleur ou que le panier est redessiné : on le repose.
  var majPrevue = false;
  function majInterfacePlusTard() {
    if (majPrevue) return;
    majPrevue = true;
    requestAnimationFrame(function () {
      majPrevue = false;
      majInterface();
    });
  }

  var observateur = new MutationObserver(function (mutations) {
    var champs = new Set();
    var interfaceTouchee = false;
    mutations.forEach(function (m) {
      if (m.type === 'attributes') {
        var el = m.target;
        var n = parseInt(el.getAttribute('data-eline-lot') || '0', 10);
        if (n > 1 && (el.getAttribute('step') !== String(n) || el.getAttribute('data-min') !== String(n))) champs.add(el);
        return;
      }
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches(CHAMPS)) champs.add(node);
        else node.querySelectorAll(CHAMPS).forEach(function (c) {
          champs.add(c);
        });
        if (node.matches('[name="checkout"], .cart__ctas, #cart-notification-form') || node.querySelector('[name="checkout"]')) {
          interfaceTouchee = true;
        }
      });
    });
    champs.forEach(traiterChamp);
    if (interfaceTouchee) majInterfacePlusTard();
  });

  // Quantité tapée à la main : arrondie au lot supérieur avant que le thème ne la traite
  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches(CHAMPS)) return;
      var n = parseInt(input.getAttribute('data-eline-lot') || '1', 10);
      if (!(n > 1)) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v)) return;
      if (v === 0 && !estChampProduit(input)) return; // 0 = retirer l'article
      var w = arrondir(Math.max(v, estChampProduit(input) ? n : 1), n);
      if (w !== v) {
        input.value = w;
        avis(texte('arrondi', { n: n, q: w }));
      }
    },
    true
  );

  // Ajout au panier depuis une fiche : la quantité envoyée est toujours un multiple du lot
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      var action = (form && form.getAttribute && form.getAttribute('action')) || '';
      if (action.indexOf('/cart/add') === -1) return;
      // form.elements inclut le champ quantité placé hors du formulaire (attribut form=)
      var input = form.elements && form.elements.namedItem ? form.elements.namedItem('quantity') : null;
      if (input && !input.tagName && input.length) input = input[0];
      if (!input || input.type !== 'number') return;
      var n = parseInt(input.getAttribute('data-eline-lot') || '1', 10);
      if (!(n > 1)) return;
      var v = parseInt(input.value, 10) || 0;
      var w = arrondir(Math.max(v, n), n);
      if (w !== v) {
        input.value = w;
        avis(texte('arrondi', { n: n, q: w }));
      }
    },
    true
  );

  /* ---------- Panier : état, correction des lots, minimum ---------- */

  var etat = {
    total: (D.panier && D.panier.total) || 0,
    nombre: (D.panier && D.panier.nombre) || 0,
    aJour: true,
  };
  var promesseRafraichir = null;
  var relancer = false;
  var minuteurRafraichir;

  function seuil() {
    var taux = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
    return Math.round(MINIMUM * taux);
  }

  function sousMinimum() {
    return MINIMUM > 0 && etat.nombre > 0 && etat.total < seuil();
  }

  function argent(centimes) {
    var devise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || D.devise || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: devise }).format(
        centimes / 100
      );
    } catch (e) {
      return (centimes / 100).toFixed(2) + ' ' + devise;
    }
  }

  function boutonsCommande() {
    return document.querySelectorAll('button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout');
  }

  // Le message se place juste au-dessus des boutons de commande (panier, fenêtre « ajouté au panier »)
  function messagePour(bouton) {
    var parent, repere;
    var formNotif = bouton.closest('#cart-notification-form');
    var ctas = bouton.closest('.cart__ctas');
    if (formNotif) {
      parent = formNotif.parentElement;
      repere = formNotif;
    } else if (ctas) {
      parent = ctas.parentElement;
      repere = ctas;
    } else {
      parent = bouton.parentElement;
      repere = bouton;
    }
    if (!parent) return null;
    var precedent = repere.previousElementSibling;
    if (precedent && precedent.classList.contains('eline-minimum')) return precedent;
    var msg = document.createElement('p');
    msg.className = 'eline-minimum';
    msg.setAttribute('role', 'status');
    msg.hidden = true;
    parent.insertBefore(msg, repere);
    return msg;
  }

  function majInterface() {
    var bloque = sousMinimum();
    var t = bloque ? texte('minimum', { min: argent(seuil()), reste: argent(seuil() - etat.total) }) : '';
    boutonsCommande().forEach(function (b) {
      if (bloque) {
        if (!b.disabled) {
          b.disabled = true;
          b.dataset.elineBloque = '1';
        }
      } else if (b.dataset.elineBloque) {
        delete b.dataset.elineBloque;
        if (etat.nombre > 0) b.disabled = false;
      }
      var msg = messagePour(b);
      if (msg) {
        if (msg.textContent !== t) msg.textContent = t;
        if (msg.hidden === bloque) msg.hidden = !bloque;
      }
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (el) {
      var d = bloque ? 'none' : '';
      if (el.style.display !== d) el.style.display = d;
    });
  }

  function json(r) {
    return r.json();
  }

  function rafraichirBulle() {
    return fetchOrigine(RACINE + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(json)
      .then(function (s) {
        var bulle = document.getElementById('cart-icon-bubble');
        if (!bulle || !s || !s['cart-icon-bubble']) return;
        var html = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var contenu = html.querySelector('.shopify-section') || html.body;
        bulle.innerHTML = contenu.innerHTML;
      })
      .catch(function () {});
  }

  function corrigerLots(panier) {
    var items = (panier && panier.items) || [];
    return Promise.all(
      items.map(function (it) {
        if (lotsVariante[it.variant_id]) return lotsVariante[it.variant_id];
        return lotParHandle(it.handle).then(function (n) {
          lotsVariante[it.variant_id] = n;
          return n;
        });
      })
    ).then(function (lots) {
      var maj = {};
      var nb = 0;
      items.forEach(function (it, i) {
        var n = lots[i];
        if (n > 1 && it.quantity % n) {
          maj[it.key] = arrondir(it.quantity, n);
          nb++;
        }
      });
      if (!nb) return panier;
      return fetchOrigine(RACINE + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: maj }),
      })
        .then(json)
        .then(function (nouveau) {
          if (document.getElementById('main-cart-items')) {
            try {
              sessionStorage.setItem('eline-avis', T.corrige || '');
            } catch (e) {}
            window.location.reload();
          } else {
            avis(T.corrige);
            rafraichirBulle();
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'eline-regles', cartData: nouveau });
              } catch (e) {}
            }
          }
          return nouveau && nouveau.items ? nouveau : panier;
        });
    });
  }

  function rafraichir() {
    if (promesseRafraichir) {
      relancer = true;
      return promesseRafraichir;
    }
    etat.aJour = false;
    promesseRafraichir = fetchOrigine(RACINE + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(json)
      .then(corrigerLots)
      .then(function (panier) {
        etat.total = panier.total_price || 0;
        etat.nombre = panier.item_count || 0;
      })
      .catch(function () {})
      .then(function () {
        promesseRafraichir = null;
        etat.aJour = true;
        majInterface();
        if (relancer) {
          relancer = false;
          return rafraichir();
        }
      });
    return promesseRafraichir;
  }

  function planifierRafraichir() {
    etat.aJour = false;
    clearTimeout(minuteurRafraichir);
    minuteurRafraichir = setTimeout(rafraichir, 150);
  }

  // Toute modification du panier (ajout, quantité, suppression) relance la vérification
  window.fetch = function (ressource) {
    var p = fetchOrigine.apply(window, arguments);
    try {
      var url = typeof ressource === 'string' ? ressource : (ressource && (ressource.url || ressource.href)) || String(ressource);
      if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url)) p.then(planifierRafraichir, planifierRafraichir);
    } catch (e) {}
    return p;
  };

  // « Passer commande » : bloqué sous le minimum, et tant que le panier est en cours de vérification
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      var bouton = e.submitter;
      var commande =
        (bouton && bouton.name === 'checkout') || (form && form.getAttribute && form.getAttribute('id') === 'cart-notification-form');
      if (!commande) return;
      if (form.dataset.elineValide === '1') {
        delete form.dataset.elineValide;
        return;
      }
      if (etat.aJour && !sousMinimum()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      (etat.aJour ? Promise.resolve() : rafraichir()).then(function () {
        if (sousMinimum()) {
          majInterface();
          var msg = document.querySelector('.eline-minimum:not([hidden])');
          if (msg) msg.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        form.dataset.elineValide = '1';
        var envoi = bouton && bouton.form === form ? bouton : null;
        if (envoi && envoi.disabled) envoi.disabled = false;
        if (form.requestSubmit) form.requestSubmit(envoi || undefined);
        else form.submit();
      });
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var lien = e.target && e.target.closest && e.target.closest('a[href]');
      if (!lien || !/\/checkouts?(\/|\?|$)/.test(lien.getAttribute('href') || '')) return;
      if (sousMinimum()) {
        e.preventDefault();
        majInterface();
      }
    },
    true
  );

  /* ---------- Démarrage ---------- */

  function demarrer() {
    traiterTout(document);
    majInterface();
    observateur.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['step', 'data-min'],
    });
    try {
      var message = sessionStorage.getItem('eline-avis');
      if (message) {
        sessionStorage.removeItem('eline-avis');
        avis(message);
      }
    } catch (e) {}
    var horsLot = ((D.panier && D.panier.lignes) || []).some(function (l) {
      return l.lot > 1 && l.quantite % l.lot;
    });
    if (horsLot) rafraichir();
  }

  window.elineRegles = { rafraichir: rafraichir, etat: etat, lotParHandle: lotParHandle, sousMinimum: sousMinimum };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
